import {BackBtn} from '../../theme/icons';
import {StyleSheet, TouchableOpacity, Platform, Image} from 'react-native';
import React from 'react';
import images from '../../theme/images';

function GoBack_btn_copy({navigation, color, paddingLeft = false}) {
  return (
    <TouchableOpacity
      onPress={() => {
        navigation.goBack()
      }}
      style={[styles.goBackButton, Platform.OS == "web" ? styles.leftSection : null ]}
      >
        {
          Platform.OS !== "web" ? (
            <BackBtn  style={{color: color}}/>
          ) : (
            <Image source={images.leftIcon} style={[{color: color}, styles.backImage]} />
          )
        }
    </TouchableOpacity>
  );
}
export default GoBack_btn_copy;

const styles = StyleSheet.create({
  goBackButton: {
    paddingVertical: 10, 
    paddingRight: 10
  },
  backImage: {
    width: 25, 
    height: 25, 
    resizeMode: 'contain'
  },
  leftSection:{
    paddingHorizontal: 15
  },
});